"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_INJECTION_ID = void 0;
exports.APP_INJECTION_ID = '#app';
